import React from "react";
import Header from './components/header.js';
import HeadingEvents from './components/heading-events.js';

const Events = () => {
    return (
        <div className="body">
            <div className="grid-pattern">
                <Header />
                <HeadingEvents />
            </div>
        </div>
    );
};

export default Events;
